import { motion, useTransform, useScroll } from "framer-motion";
import React, { useRef } from "react";
import {HiArrowRight} from "react-icons/hi2";
import {BsArrow90DegRight} from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["5%", "-95%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh] ">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{ x }} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id} />;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({ card }) => {
    return (
        <div
            key={card.id}
            className="group relative h-screen overflow-hidden flex items-center"
        >
            <div className="flex">
                <div className="px-4 w-[40rem] py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                    <div className="group" href="#">
                        <motion.div
                            className="relative pt-[50%] sm:pt-[75%] rounded-xl overflow-hidden"
                            variants={{
                                hidden: { opacity: 0, x: -50 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            transition={{duration: 0.6, delay: 0.4}}
                            viewport={{once: false}}
                        >
                            <img
                                className="size-full absolute top-0 start-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl"
                                src={card.imgURL}
                                alt="Description"
                            />
                            <div className="absolute top-0 end-0 rounded-se-xl rounded-es-xl text-xs font-medium bg-pink-500 text-white py-1.5 px-3">
                                Step No.{ card.id }
                            </div>
                        </motion.div>
                        <div className="mt-7">
                            <h3 className="text-2xl font-bold text-pink-500">
                                { card.step }
                            </h3>
                            <p className="text-lg italic mt-3 text-gray-600 w-full">
                                { card.content }
                            </p>
                        </div>
                    </div>
                </div>
                { card.id!==6 ?
                    <motion.div
                        className="text-6xl my-auto mx-16"
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <HiArrowRight />
                    </motion.div> :
                    <motion.div
                        className="my-auto text-6xl mx-16"
                        variants={{
                            hidden: { opacity: 0, y: -50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <BsArrow90DegRight className="rotate-90" />
                    </motion.div> }
            </div>
        </div>
    );
};

const cards = [
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/workflow-1.png",
        step: "Bacteria strain selection",
        content: "BL21 Competent Escherichia coli (E. coli) strain",
        id: 1
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/workflow-2.png",
        step: "Genes overexpression",
        content: "Overexpress guaA and guaB by engineered pET-45b plasmid",
        id: 2
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/workflow-3.png",
        step: "Genes knock-down",
        content: "Inhibit the transcription of guaD and xdh by CRISPRi",
        id: 3
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/workflow-4.png",
        step: "Guanine assay",
        content: "Measure the concentration of guanine by commercial kits",
        id: 4
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/workflow-5.png",
        step: "Continuous culture",
        content: "Long-term culturing of engineered E. coli for guanine accumulation",
        id: 5,
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/workflow-6.png",
        step: "Guanine crystal purification",
        content: "Extract biomineralized guanine at high concentration and purity, ready for real-world applications",
        id: 6,
    }
];

export default function HorizontalScrollWorkflow(){
    return(
        <HorizontalScrollCarousel />
    )
}